import React, { useState } from "react";
import PropTypes from "prop-types";
import "./Tooltip.scss";
import { Portal } from "react-portal";

function Tooltip({
  isPopover = false,
  tooltipForTableHeader = false,
  children,
}) {
  const [isActive, setIsActive] = useState(false);
  const [coords, setCoords] = useState({ left: 0, top: 0 });
  const showToolTip=()=>{
    setIsActive(true);
  }
  const hideToolTip = () => {
    setIsActive(false);
  };
  const toggle = () => {
    setIsActive(!isActive);
  };
  const setTooltipPosition = (e) => {
    e.stopPropagation();
    const rect = e.target.getBoundingClientRect();
    const rightEdgeLimit = document.body.clientWidth - 40;
    let centeredXPosition = rect.x + rect.width / 2;
    if (rect.x + rect.width > rightEdgeLimit) {
      centeredXPosition = centeredXPosition - rect.width / 2;
    }
    setCoords({
      left: centeredXPosition,
      top: rect.y - 30 + window.scrollY,
    });
  };

  const mouseOverEvent = (e) => {
    if (isPopover) return null;
    if (tooltipForTableHeader) setTooltipPosition(e);
    showToolTip();
  };
  const onClickEvent = (e) => {
    if (!isPopover) return null;
    if (tooltipForTableHeader) setTooltipPosition(e);
    toggle();
  };
  const mouseOutEvent = (e) => {
    if (isPopover) return null;
    hideToolTip();
  };
  return (
    <div
      className="tooltip-container"
      onMouseOver={mouseOverEvent}
      onMouseOut={mouseOutEvent}
      onClick={onClickEvent}
    >
      {children[0]}
      {isActive && !tooltipForTableHeader && (
        <div className={`tooltip-tip-section top`}>{children[1]}</div>
      )}
      {isActive && tooltipForTableHeader && (
        <Portal>
          <div
            className={`tooltip-tip-section-portal top`}
            style={{ ...coords }}
          >
            {children[1]}
          </div>
        </Portal>
      )}
    </div>
  );
}

Tooltip.propTypes = {
  isPopover: PropTypes.bool,
  tooltipForTableHeader: PropTypes.bool,
  children: PropTypes.arrayOf(PropTypes.element),
};
export default Tooltip;
